module.exports = __webpack_public_path__ + "img/patient_w.55f447b5.png";